import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const PayoutsPage = lazy(() => import('@/pages/payouts'));

export const Route = createFileRoute('/payouts')({
  component: function PayoutsRoute() {
    return (
      <Suspense fallback={<TableSkeleton />}>
        <PayoutsPage />
      </Suspense>
    );
  },
});
